import { createFileRoute } from "@tanstack/react-router";
import { DatasourceBrowser } from "src/containers/DatasourceBrowser";
import { validateBrowserSearch } from "src/services/datasources/browserSearchSchema";

export const Route = createFileRoute("/_layout-nosidebar/documents")({
    component: Documents,
    validateSearch: validateBrowserSearch,
});

function Documents() {
    return <DatasourceBrowser kind="document" />;
}
